// extracted by mini-css-extract-plugin
export default {"subStack":"subStackItem_subStack__cWYdW","item":"subStackItem_item__8lNAo","subStackTitle":"subStackItem_subStackTitle__Q3iwu"};